import Vue from 'vue';

Vue.component('popup-component', {
    props: {
        popupId: {
            type: String,
            required: true,
        },
        showOnlyOnce: {
            type: Boolean,
            default: true,
        },
        storageKeyPrefix: {
            type: String,
            default: 'popup_seen_',
        },
    },

    data() {
        return {
            isVisible: false,
        };
    },

    computed: {
        storageKey() {
            return this.storageKeyPrefix + this.popupId;
        },

        // Check if Cypress is running
        isCypressRunning() {
            return typeof window !== 'undefined' && window.Cypress;
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.checkAndShowPopup();
        });
    },

    methods: {
        checkAndShowPopup() {
            // Skip showing popup if Cypress is running
            if (this.isCypressRunning) {
                console.log('Cypress detected, skipping popup display');
                return;
            }

            // If we don't need to check storage or the popup hasn't been seen yet, show it
            if (!this.showOnlyOnce || !this.hasBeenSeen()) {
                setTimeout(() => {
                    this.showPopup();
                }, 500); // Short delay for better UX
            }
        },

        hasBeenSeen() {
            try {
                return localStorage.getItem(this.storageKey) === 'true';
            } catch (e) {
                console.error('Error accessing localStorage:', e);
                return false;
            }
        },

        showPopup() {
            this.isVisible = true;
            document.body.classList.add('popup-open');
            this.$el.classList.add('is-visible');
        },

        hidePopup() {
            this.isVisible = false;
            document.body.classList.remove('popup-open');
            this.$el.classList.remove('is-visible');

            // Mark as seen in local storage
            if (this.showOnlyOnce) {
                try {
                    // Remove all existing entries with the same prefix
                    this.removeAllConsentEntries();
                    // Save the current popup's consent status
                    localStorage.setItem(this.storageKey, 'true');
                } catch (e) {
                    console.error('Error writing to localStorage:', e);
                }
            }
        },

        removeAllConsentEntries() {
            try {
                // Get all keys from localStorage
                const keys = Object.keys(localStorage);

                // Filter keys that start with the storageKeyPrefix or the default 'popup_seen_'
                const consentKeys = keys.filter(
                    (key) =>
                        key.startsWith(this.storageKeyPrefix) ||
                        (this.storageKeyPrefix !== 'popup_seen_' &&
                            key.startsWith('popup_seen_')),
                );

                // Remove all consent entries except the current one
                consentKeys.forEach((key) => {
                    if (key !== this.storageKey) {
                        localStorage.removeItem(key);
                    }
                });
            } catch (e) {
                console.error('Error clearing localStorage consents:', e);
            }
        },

        closeWithoutSaving(event) {
            // Only close if clicking directly on the overlay, not on the modal itself
            if (event.target === event.currentTarget) {
                this.isVisible = false;
                document.body.classList.remove('popup-open');
                this.$el.classList.remove('is-visible');
                // Intentionally not saving to localStorage
            }
        },
    },
});
